module.exports = __webpack_public_path__ + "img/dessin-borne.28129c74.svg";